import React, {FC, ReactNode} from 'react';

export interface CategoryProps {
    children: ReactNode;
    label: string;
}

const Category: FC<CategoryProps> = ({children}: CategoryProps) => {
    return <>{children}</>;
};

export default Category;
